'use client'

import * as React from 'react'
import type { Link as LinkSchema } from '@/contentful/generated/schemas'
import { getCtaLinkBehavior, getCtaLinkType } from '@/contentful/link-cta'
import { useSession } from 'next-auth/react'

import { JOIN_MEMCO_CTA } from '@/lib/constants'
import { MembershipType } from '@/lib/entitlements/membership-type'
import { preventDefault } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Link as UiLink } from '@/components/ui/link'
import { openMemcoWindow } from '@/components/memco-modal'

function noop() {}

export const Link = ({ link }: { link: LinkSchema }) => {
  const { data: session } = useSession()
  const isMemco = session?.user.membershipTypes.includes(MembershipType.MEMCO)
  const { href, name, variant, memcoOffer, outgoingVendor } = link.fields
  if (!href || !name) return null
  const linkType = getCtaLinkType(link)
  const buttonVariant = variant || 'primary'
  const showModal = memcoOffer && !isMemco

  return (
    <Button variant={buttonVariant} asChild className="w-fit whitespace-normal">
      <UiLink
        role={showModal ? 'button' : 'link'}
        href={href}
        onClick={showModal ? preventDefault(openMemcoWindow) : noop}
        {...(!showModal ? getCtaLinkBehavior(link) : {})}
        {...(linkType && { 'data-link-type': linkType })}
        data-vendor-name={outgoingVendor}
      >
        {showModal ? JOIN_MEMCO_CTA : name}
      </UiLink>
    </Button>
  )
}
